import { render } from "./ReservationInfo.vue?vue&type=template&id=3667c786"
import script from "./ReservationInfo.vue?vue&type=script&lang=js"
export * from "./ReservationInfo.vue?vue&type=script&lang=js"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__